<template>
  <div class="customerInvoiceDetail">
    <div style="padding: 0 10px;height: calc(100vh - 140px);overflow-y: auto;">
      <el-form
        ref="formDataRef"
        label-position="top"
        size="small"
        :model="formData"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <!--客户-->
            <el-form-item
              :label="$t('orderCenterCont.customer')"
              prop="customerId"
              style="width: 100%"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: 'change' }
              ]"
            >
              <el-select
                v-model="formData.customerId"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
                remote
                reserve-keyword
                :remote-method="getUserOption"
                @visible-change="changeUserOption"
                @change="customerChange"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.username + '（' + item.id + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--业务类型-->
            <el-form-item
              :label="$t('collectionCenter.businessT')"
              prop="businessType"
              style="width: 100%"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: 'change' }
              ]"
            >
              <el-select
                v-model="formData.businessType"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option key="0" :label="$t('collectionCenter.expressDelivery')" :value="0" />
                <el-option key="1" :label="$t('collectionCenter.lanshou')" :value="1" />
                <el-option key="2" :label="$t('basicData.StockingAndPickup')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse v-model="activeName" accordion @change="handleChange">
          <el-collapse-item
            v-for="(item, key) in formElement.elementForm"
            :key="key"
            :name="key"
          >
            <template slot="title">
              <span v-if="item.length > 0" style="font-size: 16px;font-weight: bold">{{ item[0].titleOption[$i18n.locale] }}</span>
              <span v-else style="font-size: 16px;font-weight: bold">{{ formElementFixed[key][0].titleOption[$i18n.locale] }}</span>
              <el-tooltip
                v-if="formElementFixed[key][0].tip"
                class="item"
                effect="dark"
                placement="top"
              >
                <template slot="content">{{ formElementFixed[key][0].tip[$i18n.locale] }}</template>
                <span style="margin-left: 5px;"><i style="font-size: 18px" class="el-icon-warning" /></span>
              </el-tooltip>
            </template>
            <div v-if="item.length > 0">
              <div v-for="(item1, index) in formElement.elementForm[key]" :key="index">
                <el-card style="margin-bottom: 10px;">
                  <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                    {{ item1.titleOption[$i18n.locale] + (index + 1) }}
                    <el-button
                      v-if="viewType !== 1"
                      size="small"
                      type="danger"
                      style="float: right"
                      @click="removeForm(key, index)"
                    >{{ $t('collectionCenter.Delete') }}</el-button>
                  </div>
                  <el-row :gutter="10">
                    <el-col v-for="field in item1.column" :key="field.field" :span="8">
                      <el-form-item
                        :label="field.titleOption[$i18n.locale]"
                        :prop="`form.${key}.${index}.${field.field}`"
                        :rules="getValidationRules(field, key, index)"
                      >
                        <template slot="label">
                          {{ field.titleOption[$i18n.locale] }}
                          <el-tooltip
                            v-if="field.tip"
                            class="item"
                            effect="dark"
                            placement="top"
                          >
                            <template slot="content">{{ field.tip[$i18n.locale] }}</template>
                            <span style="margin-left: 5px;"><i style="font-size: 18px" class="el-icon-warning" /></span>
                          </el-tooltip>
                        </template>
                        <!-- 条件渲染不同组件 -->
                        <el-input
                          v-if="field.type === 'input'"
                          :value="getFieldValue(key, index, field.field)"
                          :placeholder="$t('collectionCenter.pleaseInput')"
                          :style="{width: field.field === 'cep' || field.field === 'cnpj' ? 'calc(100% - 35px)' : '100%'}"
                          @input="updateFieldValue(key, index, field.field, $event)"
                        />
                        <el-input
                          v-else-if="field.type === 'textarea'"
                          type="textarea"
                          :rows="3"
                          :value="getFieldValue(key, index, field.field)"
                          :placeholder="$t('collectionCenter.pleaseInput')"
                          style="width: 100%"
                          @input="updateFieldValue(key, index, field.field, $event)"
                        />

                        <el-select
                          v-else-if="field.type === 'select'"
                          :value="getFieldValue(key, index, field.field)"
                          :placeholder="$t('collectionCenter.pleaseChoose')"
                          clearable
                          :multiple="field.multiple"
                          style="width: 100%"
                          @input="updateFieldValue(key, index, field.field, $event)"
                        >
                          <el-option
                            v-for="option in field.options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                          />
                        </el-select>

                        <el-radio-group
                          v-else-if="field.type === 'radio'"
                          :value="getFieldValue(key, index, field.field)"
                          @input="updateFieldValue(key, index, field.field, $event)"
                        >
                          <el-radio
                            v-for="option in field.options"
                            :key="option.value"
                            :label="option.value"
                          >
                            {{ option.label }}
                          </el-radio>
                        </el-radio-group>

                        <el-checkbox-group
                          v-else-if="field.type === 'checkbox'"
                          :value="getFieldValue(key, index, field.field)"
                          @input="updateFieldValue(key, index, field.field, $event)"
                        >
                          <el-checkbox
                            v-for="option in field.options"
                            :key="option.value"
                            :label="option.value"
                          >
                            {{ option.label }}
                          </el-checkbox>
                        </el-checkbox-group>
                        <el-popover
                          v-if="field.field === 'cep'"
                          v-model="visibleCep[key + index]"
                          placement="top-end"
                          width="260"
                          trigger="manual"
                        >
                          <div>
                            <div style="text-align: right">
                              <el-button
                                type="text" size="mini" style="padding: 0"
                                @click="visibleCep[key + index] = false"
                              >
                                <i class="el-icon-close" style="font-size: 18px" />
                              </el-button>
                            </div>
                            <div>
                              {{ $t('mdfeTranslate.IBGECode') }}：
                              <el-tooltip
                                v-if="addressData[key + index]"
                                class="item" effect="light"
                                placement="right"
                              >
                                <template slot="content">
                                  <div>
                                    <el-button type="text" size="mini" @click="copy(addressData[key + index].cityCode)">{{ $t('orderDetails.copy') }}</el-button>
                                  </div>
                                </template>
                                <span>{{ addressData[key + index].cityCode }}</span>
                              </el-tooltip>
                            </div>
                            <div>
                              {{ $t('collectionCenter.city') }}：
                              <el-tooltip
                                v-if="addressData[key + index]"
                                class="item" effect="light"
                                placement="right"
                              >
                                <template slot="content">
                                  <div>
                                    <el-button type="text" size="mini" @click="copy(addressData[key + index].city)">{{ $t('orderDetails.copy') }}</el-button>
                                  </div>
                                </template>
                                <span>{{ addressData[key + index].city }}</span>
                              </el-tooltip>
                            </div>
                            <div>
                              {{ $t('collectionCenter.state') }}：
                              <el-tooltip
                                v-if="addressData[key + index]"
                                class="item" effect="light"
                                placement="right"
                              >
                                <template slot="content">
                                  <div>
                                    <el-button type="text" size="mini" @click="copy(addressData[key + index].uf)">{{ $t('orderDetails.copy') }}</el-button>
                                  </div>
                                </template>
                                <span>{{ addressData[key + index].uf }}</span>
                              </el-tooltip>
                            </div>
                          </div>
                          <el-button
                            slot="reference"
                            type="primary"
                            plain
                            :disabled="viewType === 1"
                            style="padding: 4px 5px;float:right;"
                            @click="showCepInfo(key, index, field.field)"
                          >
                            <i class="el-icon-search" style="font-size: 22px" />
                          </el-button>
                        </el-popover>
                        <el-popover
                          v-if="field.field === 'cnpj'"
                          v-model="visibleCnpj[key + index]"
                          placement="top"
                          width="300"
                          trigger="manual"
                        >
                          <div v-if="cnpjData[key + index]">
                            <div style="text-align: right">
                              <el-button
                                type="text" size="mini" style="padding: 0"
                                @click="visibleCnpj[key + index] = false"
                              >
                                <i class="el-icon-close" style="font-size: 18px" />
                              </el-button>
                            </div>
                            <el-form
                              :ref="key + index + 'Ref'"
                              :model="cnpjData"
                              label-position="top"
                              size="small"
                            >
                              <el-form-item
                                label="cnpj"
                                :prop="key + index + '.cnpj'"
                                :rules="[{ required: true, message: $t('collectionCenter.pleaseInput'), trigger: ['blur', 'change'] }]"
                              >
                                <el-input v-model="cnpjData[key + index].cnpj" />
                              </el-form-item>
                              <el-form-item
                                :label="$t('mdfeTranslate.StateAbbreviationUF')"
                                :prop="key + index + '.state'"
                                :rules="[{required: true, message: $t('collectionCenter.pleaseChoose'), trigger: ['blur', 'change']}]"
                              >
                                <el-select
                                  v-model="cnpjData[key + index].state"
                                  :placeholder="$t('placeOrder.pleaseChoose')"
                                  clearable
                                  filterable
                                  style="width: 100%"
                                >
                                  <el-option
                                    v-for="item in senderStateList"
                                    :key="item.id"
                                    :label="item.shortName"
                                    :value="item.shortName"
                                  />
                                </el-select>
                              </el-form-item>
                            </el-form>
                            <div style="margin-bottom: 10px;">
                              <el-button type="primary" @click="getCnpjInfo(key, index, field.field)">{{ $t('collectionCenter.search') }}</el-button>
                            </div>
                            <div>
                              <div>
                                cnpj：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].cnpj)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].cnpj }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--名称-->
                                {{ $t('customerManagements.CompanyName') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].name)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].name }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--公司简称：-->
                                {{ $t('mdfeTranslate.CompanyAbbreviation') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].abbreviation)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].abbreviation }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                ie：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].ieNumber)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].ieNumber }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--电话：-->
                                {{ $t('collectionCenter.phone') }}
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].phone)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].phone }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--邮编：-->
                                {{ $t('collectionCenter.Zip') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].cep)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].cep }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--区：-->
                                {{ $t('collectionCenter.Area') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].area)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].area }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--州：-->
                                {{ $t('mdfeTranslate.State') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].state)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].state }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--城市：-->
                                {{ $t('collectionCenter.city') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].city)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].city }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--城市代码：-->
                                {{ $t('mdfeTranslate.cityCode') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].cityCode)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].cityCode }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--街道：-->
                                {{ $t('collectionCenter.RecipientStreet') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].street)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].street }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--门牌号：-->
                                {{ $t('orderCenterCont.HouseNumber') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].houseNumber)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].houseNumber }}</span>
                                </el-tooltip>
                              </div>
                              <div>
                                <!--补充地址：-->
                                {{ $t('mdfeTranslate.SupplementalAddress') }}：
                                <el-tooltip
                                  class="item" effect="light"
                                  placement="right"
                                >
                                  <template slot="content">
                                    <div>
                                      <el-button type="text" size="mini" @click="copy(cnpjData[key + index].complement)">{{ $t('orderDetails.copy') }}</el-button>
                                    </div>
                                  </template>
                                  <span>{{ cnpjData[key + index].complement }}</span>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                          <el-button
                            slot="reference"
                            type="primary"
                            plain
                            :disabled="viewType === 1"
                            style="padding: 4px 5px;float:right;"
                            @click="showCnpjInfo(key, index, field.field)"
                          >
                            <i class="el-icon-search" style="font-size: 22px" />
                          </el-button>
                        </el-popover>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </div>
            </div>
            <el-button
              v-if="viewType !== 1"
              size="small" type="primary" @click="addForm(key)"
            >{{ $t('orderCenterCont.add') }}</el-button>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div style="text-align: right;padding: 20px;border-top: 1px solid #ccc;">
      <el-button
        v-if="viewType !== 1"
        size="small" type="primary" @click="onStoredDetailForm()"
      >{{ $t('collectionCenter.Stored') }}</el-button>
      <el-button
        v-if="viewType !== 1"
        size="small" type="primary" @click="onSubmitDetailForm()"
      >{{ $t('collectionCenter.submit') }}</el-button>
      <el-button
        size="small" plain @click="onCloseDetailWindow(false)"
      >{{ $t('collectionCenter.cancel') }}</el-button>
    </div>
  </div>
</template>
<script>
import { apiGetCustomerPage } from '@/api/finance/contasDeClientes';
import { addOrUpdateNewInvoiceSubject, getAddressByZipCode, getInvoiceSubjectByCnpj } from '@/api/invoiceCenter';
import { selectState } from '@/api/orderApi';
import { copyData } from '@/utils/copyData';
export default {
  name: 'CustomerInvoiceDetail',
  props: {
    viewType: {
      type: Number,
      default: 0
    },
    formElement: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formElementFixed: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    // cnpj
    // const checkcnpj = (rule, value, callback) => {
    //   const cnpjRegex = /^[A-Za-z0-9]{9}[0-9]{2}$|^[A-Za-z0-9]{12}[0-9]{2}$/;
    //   if (!value) {
    //     return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
    //   } else {
    //     if (!cnpjRegex.test(value)) {
    //       return callback(new Error(this.$t('mdfeTranslate.enter11Digits14'))); // 输入11位或14位数字
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    return {
      formData: {},
      formOption: {
        // 显示重置表单按扭
        submitBtn: false,
        resetBtn: false,
        form: {
          labelPosition: 'top'
        },
        // 添加全局配置
        global: {
          colon: true
        }
      },
      activeName: null,
      customerList: [],
      addressData: {},
      senderStateList: [],
      visibleCep: {},
      visibleCnpj: {},
      cnpjData: {}
      // checkcnpj
    };
  },
  created() {
    this.createForm();
    this.getState();
  },
  methods: {
    // 获取cnpj信息
    getCnpjInfo(key, index, field) {
      const refs = key + index + 'Ref';
      this.$refs[refs][0].validate(async valid => {
        if (!valid) {
          return;
        }
        const queryParam = {
          cnpj: this.cnpjData[key + index].cnpj,
          state: this.cnpjData[key + index].state
        };
        getInvoiceSubjectByCnpj(queryParam).then(res => {
          const { data } = res;
          if (data && data.name) {
            const param = {
              cnpj: data.cnpj,
              state: data.state ? data.state : queryParam.state,
              abbreviation: data.abbreviation,
              area: data.area,
              cep: data.cep,
              city: data.city,
              cityCode: data.cityCode,
              complement: data.complement,
              houseNumber: data.houseNumber,
              ieNumber: data.ieNumber,
              name: data.name,
              phone: data.phone,
              street: data.street
            };
            this.$set(this.cnpjData, key + index, param);
          } else {
            const param = {
              cnpj: '',
              state: '',
              abbreviation: '',
              area: '',
              cep: '',
              city: '',
              cityCode: '',
              complement: '',
              houseNumber: '',
              ieNumber: '',
              name: '',
              phone: '',
              street: ''
            };
            this.$set(this.cnpjData, key + index, param);
            this.$message.error(this.$t('mdfeTranslate.NoCompanyRegistrationInformation'));
          }
        }).catch(() => {
          const param = {
            cnpj: '',
            state: '',
            abbreviation: '',
            area: '',
            cep: '',
            city: '',
            cityCode: '',
            complement: '',
            houseNumber: '',
            ieNumber: '',
            name: '',
            phone: '',
            street: ''
          };
          this.$set(this.cnpjData, key + index, param);
        });
      });
    },
    // 打开查询cnpj信息弹窗
    showCnpjInfo(key, index, field) {
      const param = {
        cnpj: this.getFieldValue(key, index, field),
        state: '',
        abbreviation: '',
        area: '',
        cep: '',
        city: '',
        cityCode: '',
        complement: '',
        houseNumber: '',
        ieNumber: '',
        name: '',
        phone: '',
        street: ''
      };
      this.$set(this.cnpjData, key + index, param);
      this.visibleCnpj[key + index] = !this.visibleCnpj[key + index];
    },
    // 获取州
    getState(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data.records;
        }
      });
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 打开邮编查询城信息弹窗
    async showCepInfo(key, index, field) {
      const zipCode = this.getFieldValue(key, index, field);
      const zipData = {
        cityCode: '',
        city: '',
        uf: ''
      };
      this.$set(this.addressData, key + index, zipData);
      if (zipCode && zipCode.length === 8) {
        this.visibleCep[key + index] = !this.visibleCep[key + index];
        if (this.visibleCep[key + index]) {
          const param = {
            cep: zipCode
          };
          const { data } = await getAddressByZipCode(param);
          if (data.logradouro) {
            this.$nextTick(() => {
              zipData.cityCode = data.ibge;
              zipData.city = data.localidade;
              zipData.uf = data.uf;
              this.$set(this.addressData, key + index, zipData);
            });
          } else {
            this.$message.error(this.$t('mdfeTranslate.NoCorrespondingAddress'));
          }
        }
      } else {
        this.$message.warning(this.$t('placeOrder.input8ZipCode'));
      }
    },
    // 客户选项变化
    customerChange() {
      this.formData.customerName = '';
      this.customerList.map(item => {
        if (item.id === this.formData.customerId) {
          this.formData.customerName = item.username;
        }
      });
    },
    // 客户名称列表
    getUserOption(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          userNameOrId: name
        }
      };
      console.log(name, '===name');
      apiGetCustomerPage(param).then(res => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 打开客户选项弹窗
    changeUserOption(val) {
      if (val) {
        this.getUserOption();
      }
    },
    // 获取验证规则
    getValidationRules(field, key, index) {
      const rules = [];

      // 如果字段设置了 required 为 true，则添加必填验证
      if (field.required === true) {
        rules.push({
          required: true,
          message: `${field.titleOption[this.$i18n.locale]}${this.$t('collectionCenter.notNull')}`,
          trigger: 'change'
        });
      }

      // 如果有自定义规则，则添加基础验证规则
      if (field.rule) {
        const basicRule = this.getBasicRule(field);
        if (basicRule) {
          rules.push(basicRule);
        }
      }

      return rules;
    },

    // 获取基础验证规则
    getBasicRule(field) {
      if (!field.rule) return null;

      // 如果是自定义正则表达式
      if (field.rule.startsWith('/') && field.rule.endsWith('/')) {
        try {
          const regexStr = field.rule.slice(1, -1);
          const regex = new RegExp(regexStr);
          return {
            pattern: regex,
            message: `${field.titleOption[this.$i18n.locale]}` + this.$t('operationCenter.TheFormatIsIncorrect'),
            trigger: ['blur', 'change']
          };
        } catch (e) {
          console.error('Invalid regex pattern:', field.rule);
        }
      }

      return null;
    },

    // 获取字段值
    getFieldValue(category, index, field) {
      if (this.formData.form[category] && this.formData.form[category][index]) {
        return this.formData.form[category][index][field];
      }
      return null;
    },

    // 更新字段值
    async updateFieldValue(category, index, field, value) {
      // 确保数据结构存在
      if (!this.formData.form[category]) {
        this.$set(this.formData.form, category, []);
      }
      if (!this.formData.form[category][index]) {
        this.$set(this.formData.form[category], index, {});
      }
      // 设置字段值
      this.$set(this.formData.form[category][index], field, value);
      if (value === '' || value === null || value === undefined || value.length === 0) {
        this.checkAndResetValidation(category, index);
      }
    },
    // 检查当前行是否所有字段都为空，并重置验证
    checkAndResetValidation(category, index) {
      const currentRow = this.formData.form[category][index];
      console.log(currentRow, '===currentRow');
      // 检查当前行是否所有字段都为空
      const allFieldsEmpty = Object.values(currentRow).every(val =>
        val === null || val === undefined || val === '' || val.length === 0
      );

      if (allFieldsEmpty) {
        // 延迟执行，确保 DOM 更新完成
        this.$nextTick(() => {
          this.resetFieldValidation(category, index);
        });
      }
    },
    // 重置当前行的字段验证
    resetFieldValidation(category, index) {
      // 获取表单引用
      const formRef = this.$refs.formDataRef;
      if (formRef && formRef.clearValidate) {
        // 获取当前行的所有字段路径
        const fieldPaths = this.formElement.elementForm[category][index].column.map(
          field => `${category}.${index}.${field.field}`
        );

        // 清除这些字段的验证
        formRef.clearValidate(fieldPaths);
      }
    },
    // 生成表单
    createForm() {
      if (this.formElement.customerName) {
        this.customerList = [{ username: this.formElement.customerName, id: this.formElement.customerId }];
      }
      this.formData = {
        customerName: this.formElement.customerName,
        customerId: this.formElement.customerId,
        id: this.formElement.id,
        status: this.formElement.status,
        businessType: this.formElement.businessType,
        form: {}
      };
      // 初始化数据结构
      const formValue = Object.keys(this.formElement.elementForm);
      formValue.forEach(item => {
        this.$set(this.formData.form, item, []);

        this.formElement.elementForm[item].forEach((list, ind) => {
          this.$set(this.formData.form[item], ind, {});

          list.column.forEach(list1 => {
            this.$set(this.formData.form[item][ind], list1.field, list1.value || null);
          });
        });
      });
      this.activeName = Object.keys(this.formElement.elementForm)[0]; // 使用 key 而不是 title
    },
    // 添加模块
    addForm(key) {
      if (!this.formElementFixed || !this.formElementFixed[key] || !Array.isArray(this.formElementFixed[key])) {
        return;
      }

      if (!this.formData.form[key]) {
        this.$set(this.formData.form, key, []);
      }

      const keyData = this.formElementFixed[key][0];
      this.formElement.elementForm[key].push(keyData);

      this.formData.form[key].push({});
      const newIndex = this.formData.form[key].length - 1;

      keyData.column.forEach(list1 => {
        this.$set(this.formData.form[key][newIndex], list1.field, list1.value || null);
      });
    },
    // 删除模块
    removeForm(key, index) {
      if (this.formElement.elementForm && this.formElement.elementForm[key] &&
        this.formElement.elementForm[key].length > index) {
        this.formElement.elementForm[key].splice(index, 1);
      }
      if (this.formData.form && this.formData.form[key] &&
        this.formData.form[key].length > index) {
        this.formData.form[key].splice(index, 1);
      }
    },
    // 提交
    onSubmitDetailForm() {
      this.$refs.formDataRef.validate(valid => {
        if (valid) {
          this.formData.status = 0;
          addOrUpdateNewInvoiceSubject(this.formData).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.onCloseDetailWindow(true);
            }
          });
        } else {
          this.$message.error(this.$t('orderCenterCont.requiredNotFilled'));
        }
      });
    },
    // 暂存
    onStoredDetailForm() {
      const validateFields = ['customerId', 'businessType'];

      // 创建验证Promise数组
      const validationPromises = validateFields.map(field => {
        return new Promise((resolve) => {
          this.$refs.formDataRef.validateField(field, (error) => {
            resolve({
              field,
              error: error && error.length > 0
            });
          });
        });
      });

      Promise.all(validationPromises).then(results => {
        const hasErrors = results.some(result => result.error);

        if (hasErrors) {
          this.$message.error(this.$t('orderCenterCont.requiredNotFilled'));
        } else {
          // 所有指定字段验证通过，执行暂存操作
          this.formData.status = 2;
          addOrUpdateNewInvoiceSubject(this.formData).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.onCloseDetailWindow(true);
            }
          });
        }
      });
    },
    // 折叠面板变化
    handleChange() {
      this.onCloseZipCode();
    },
    // 关闭邮编地址弹窗
    onCloseZipCode() {
      for (const key in this.visibleCep) {
        this.visibleCep[key] = false;
      }
      for (const key in this.visibleCnpj) {
        this.visibleCnpj[key] = false;
      }
    },
    // 关闭
    onCloseDetailWindow(type) {
      this.$emit('closeDetail', type);
    }
  }
};
</script>

<style>
.customerInvoiceDetail .el-card__header {
  padding: 10px;
  background: #f1f1f1;
  color: #000;
}
.customerInvoiceDetail .el-input.is-disabled .el-input__inner,
.customerInvoiceDetail .el-range-editor.is-disabled input{
  color: #000;
}
</style>
